module.exports = __webpack_public_path__ + "static/media/abby.fdcbb263.jpg";